<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/toxYSp/tc-custom/9780226145594.jpg?1702840376397" alt="This image is the cover for the book Ministry of Presence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ministry of Presence
      </h1>
      <p class="bookDescription body article font2">
        <p>Most people in the United States today no longer live their lives under the guidance of local institutionalized religious leadership, such as rabbis, ministers, and priests; rather, liberals and conservatives alike have taken charge of their own religious or spiritual practices. This shift, along with other social and cultural changes, has opened up a perhaps surprising space for chaplains—spiritual professionals who usually work with the endorsement of a religious community but do that work away from its immediate hierarchy, ministering in a secular institution, such as a prison, the military, or an airport, to an ever-changing group of clients of widely varying faiths and beliefs.<br/><br/> In <i>A Ministry of Presence</i>, Winnifred Fallers Sullivan explores how chaplaincy works in the United States—and in particular how it sits uneasily at the intersection of law and religion, spiritual care, and government regulation. Responsible for ministering to the wandering souls of the globalized economy, the chaplain works with a clientele often unmarked by a specific religious identity, and does so on behalf of a secular institution, like a hospital. Sullivan's examination of the sometimes heroic but often deeply ambiguous work yields fascinating insights into contemporary spiritual life, the politics of religious freedom, and the never-ending negotiation of religion's place in American institutional life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Winnifred Fallers Sullivan
      </h2>
      
      <p class="authorDescription body article"><B>Winnifred Fallers Sullivan</B> is professor and chair in the Department of Religious Studies at Indiana University, where she is also affiliated faculty in the Maurer School of Law. She is the author or editor of several books, including <I>The Impossibility of Religious Freedom</I>,&#160;and coeditor of <I>Politics of Religious Freedom</I>, forthcoming from the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1232d194